import React from 'react';
import SecurityDashboard from './security/SecurityDashboard';

/** Security content rendered inside AdminLayout. */
export default function AdminSecurityPage() {
  return <SecurityDashboard />;
}
